/* Dolshyne — vanilla JS bundle (FIXED - with working product links) */
(function () {
  // Year
  document.getElementById('year').textContent = new Date().getFullYear();

  // Hero stars
  const heroStars = document.getElementById('hero-stars');
  if (heroStars) {
    for (let i = 0; i < 5; i++) heroStars.insertAdjacentHTML('beforeend', '<i data-lucide="star"></i>');
  }

  // Hero sizes
  const heroSizes = [
    { label: '100g Eco Container', price: 'Rs. 550' },
  ];
  let heroSel = 0;
  const heroSizesEl = document.getElementById('hero-sizes');
  const heroPriceEl = document.getElementById('hero-price');
  function renderHeroSizes() {
    if (!heroSizesEl) return;
    heroSizesEl.innerHTML = heroSizes.map((s, i) => `
      <button class="size-btn ${i === heroSel ? 'active' : ''}" data-i="${i}">
        ${s.popular ? '<span class="pop">Popular</span>' : ''}
        <span class="lbl">${s.label}</span>
        <span class="note">${s.note || ''}</span>
      </button>
    `).join('');
    if (heroPriceEl) heroPriceEl.textContent = heroSizes[heroSel].price;
    heroSizesEl.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', () => { heroSel = +btn.dataset.i; renderHeroSizes(); });
    });
  }
  renderHeroSizes();

  // Products with FIXED working URLs (using # as placeholder - replace with actual product URLs)
  const products = [
    {
      id: 1,
      tag: 'New Arrival', 
      name: 'Berry & Cream Instant Coffee',
      desc: 'Bright mixed berries layered with a smooth, creamy finish. Best served with chilled tonic water.',
      // FIXED: Use actual product URL or checkout URL structure
      shopUrl: 'https://dolshyne.com/products/berry-cream-instant-coffee',
      addToCartUrl: 'https://dolshyne.com/cart/add?id=49250554872054',
      img: 'https://cdn.shopify.com/s/files/1/0696/5651/0710/files/berry_cream2.png?v=1778236534', 
      alt: 'Berry and cream instant coffee jar',
      variants: [{ label: '100g Eco Container', price: 'Rs. 550', taxText: '(Incl. of all taxes)' }],
    },
    {
      id: 2,
      tag: 'Bestseller', 
      name: 'Original Instant Coffee',
      desc: '100% pure Arabica + Robusta from Coorg & Chikmagalur. Smooth, rich, classic — no chicory.',
      shopUrl: 'https://dolshyne.com/products/original-instant-coffee',
      addToCartUrl: 'https://dolshyne.com/cart/add?id=46291951255798',
      img: 'https://cdn.shopify.com/s/files/1/0696/5651/0710/files/original.png?v=1778236535', 
      alt: 'Dolshyne original instant coffee jar',
      variants: [{ label: '100g Eco Container', price: 'Rs. 400', taxText: '(Incl. of all taxes)' }],
    },
    {
      id: 3,
      tag: 'Signature Specialty', 
      name: 'Vanilla Instant Coffee',
      desc: 'Sweet vanilla infused with deep roasted coffee, delivering a smooth, creamy finish. Perfect for a refreshing cold brew.',
      shopUrl: 'https://dolshyne.com/products/vanilla-instant-coffee',
      addToCartUrl: 'https://dolshyne.com/cart/add?id=46273511391478',
      img: 'https://cdn.shopify.com/s/files/1/0696/5651/0710/files/vanilla.png?v=1778236534', 
      alt: 'Vanilla instant coffee jar',
      variants: [{ label: '100g Eco Container', price: 'Rs. 550', taxText: '(Incl. of all taxes)' }],
    },
    {
      id: 4,
      tag: 'Signature Specialty', 
      name: 'Hazelnut Instant Coffee',
      desc: 'Rich hazelnut notes blended with smooth, bold coffee for a warm, nutty finish. Best enjoyed hot or over ice.',
      shopUrl: 'https://dolshyne.com/products/hazelnut-instant-coffee',
      addToCartUrl: 'https://dolshyne.com/cart/add?id=46288444555510',
      img: 'https://cdn.shopify.com/s/files/1/0696/5651/0710/files/hazelnut.png?v=1778236535', 
      alt: 'Hazelnut instant coffee jar',
      variants: [{ label: '100g Eco Container', price: 'Rs. 550', taxText: '(Incl. of all taxes)' }],
    },
  ];
  
  const productSel = products.map(() => 0);
  const productQty = products.map(() => 1);
  const productGrid = document.getElementById('product-grid');
  
  // Helper function to build cart URL with quantity
  function buildCartUrl(product, quantity) {
    // For Shopify: /cart/add?id=PRODUCT_ID&quantity=QTY
    if (product.addToCartUrl) {
      const separator = product.addToCartUrl.includes('?') ? '&' : '?';
      return `${product.addToCartUrl}${separator}quantity=${quantity}`;
    }
    // Fallback to product page
    return product.shopUrl;
  }
  
  // Helper function to handle add to cart
  function handleAddToCart(event, product, quantity) {
    event.preventDefault();
    const cartUrl = buildCartUrl(product, quantity);
    
    // Option 1: Open in new tab (for demo)
    // window.open(cartUrl, '_blank');
    
    // Option 2: Redirect in same tab (uncomment if preferred)
    window.location.href = cartUrl;
    
    // Option 3: Show alert for demo purposes
    // console.log(`Adding to cart: ${product.name}, Quantity: ${quantity}, URL: ${cartUrl}`);
    // alert(`✨ Added ${quantity} x ${product.name} to cart!\n\n(Redirecting to checkout)`);
  }
  
  function renderProducts() {
    if (!productGrid) return;
    
    productGrid.innerHTML = products.map((p, pi) => {
      const active = p.variants[productSel[pi]];
      const cartUrl = buildCartUrl(p, productQty[pi]);
      
      return `
      <div class="product-card" data-product-idx="${pi}" data-product-id="${p.id}">
       <div class="product-img">
  <img src="${p.img}" alt="${p.alt}" loading="lazy">
</div>

        
        <div class="product-body">
          <p class="tag">${p.tag}</p>
          <h3 class="product-name">${p.name}</h3>
          <p class="product-desc">${p.desc}</p>
          <div class="variant-grid">
            ${p.variants.map((v, vi) => `
              <button class="variant-btn ${productSel[pi] === vi ? 'active' : ''}" data-p="${pi}" data-v="${vi}">${v.label}</button>
            `).join('')}
          </div>
          <div class="product-foot">
            <div>
              <span class="product-price">${active.price}</span>
              <small class="tax-text">${active.taxText || ''}</small>
            </div>
            <div class="qty-wrap">
              <button class="qty-btn minus" data-p="${pi}">−</button>
              <span class="qty-value" id="qty-${pi}">${productQty[pi]}</span>
              <button class="qty-btn plus" data-p="${pi}">+</button>
            </div>
            <button class="shop-link" data-p="${pi}" data-cart-url="${cartUrl}">
              ADD TO CART <i data-lucide="shopping-cart"></i>
            </button>
          </div>
        </div>
      </div>`;
    }).join('');
    
    // Attach variant button event listeners
    productGrid.querySelectorAll('.variant-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const p = parseInt(btn.dataset.p);
        const v = parseInt(btn.dataset.v);
        if (!isNaN(p) && !isNaN(v) && productSel[p] !== v) {
          productSel[p] = v;
          renderProducts();
          if (window.lucide) lucide.createIcons();
        }
      });
    });
    
    // Attach quantity button event listeners
    productGrid.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const p = parseInt(btn.dataset.p);
        if (isNaN(p)) return;
        
        if (btn.classList.contains('plus')) {
          productQty[p]++;
        } else if (btn.classList.contains('minus')) {
          if (productQty[p] > 1) {
            productQty[p]--;
          }
        }
        
        // Update the quantity display
        const qtySpan = document.getElementById(`qty-${p}`);
        if (qtySpan) {
          qtySpan.textContent = productQty[p];
        }
        
        // Update the Add to Cart button URL
        const productCard = btn.closest('.product-card');
        if (productCard) {
          const shopBtn = productCard.querySelector('.shop-link');
          if (shopBtn) {
            const newCartUrl = buildCartUrl(products[p], productQty[p]);
            shopBtn.setAttribute('data-cart-url', newCartUrl);
          }
        }
        
        if (window.lucide) lucide.createIcons();
      });
    });
    
    // Attach add to cart button event listeners (FIXED)
    productGrid.querySelectorAll('.shop-link').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const p = parseInt(btn.dataset.p);
        if (!isNaN(p)) {
          handleAddToCart(e, products[p], productQty[p]);
        }
      });
    });
  }
  
  renderProducts();

  // Steps
  const steps = [
    { icon: 'coffee', n: '01', title: 'Scoop', desc: 'Add 1 teaspoon of Dolshyne to your favourite mug. <br> We suggest, 1.5g per 120-150 ml.' },
    { icon: 'droplets', n: '02', title: 'Pour', desc: 'Finish with hot or cold water, warm or chilled milk — or serve over ice. For a vibrant twist, try Berry & Cream topped with chilled tonic water.' },
    { icon: 'heart', n: '03', title: 'Enjoy', desc: 'Sip slowly. Notice the aroma. Make it your daily ritual — hot, iced, or blended.' },
  ];
  const stepGrid = document.getElementById('step-grid');
  if (stepGrid) {
    stepGrid.innerHTML = steps.map(s => `
      <div class="step-card">
        <span class="step-num">${s.n}</span>
        <div class="step-icon-wrap"><i data-lucide="${s.icon}"></i></div>
        <h3>${s.title}</h3>
        <p>${s.desc}</p>
      </div>
    `).join('');
  }

  // Features
  const features = [
    { icon: 'coffee', title: '100% Pure', desc: 'No chicory, no fillers — just premium Arabica & Robusta. Crafted in small, mindful batches and sealed precisely at its aromatic peak.' },
    { icon: 'map-pin', title: 'Traceable Origins', desc: "Coorg & Chikmagalur Estates" },
    { icon: 'recycle', title: 'Eco Packaging', desc: 'Recyclable containers & pouches — conscious sipping.' },
    { icon: 'sparkles', title: 'Artisanal Craft', desc: 'Curated in small batches, hand-selected & quality-checked.' },
  ];
  const featuresGrid = document.getElementById('features-grid');
  if (featuresGrid) {
    featuresGrid.innerHTML = features.map(f => `
      <div class="feature-card">
        <i data-lucide="${f.icon}"></i>
        <h3>${f.title}</h3>
        <p>${f.desc}</p>
      </div>
    `).join('');
  }

  // Shipping
  const ships = [
    { icon: 'truck', title: 'Free Shipping', desc: 'On all orders above ₹799. Pan-India delivery in 3–5 business days.' },
    { icon: 'package', title: 'Fast Dispatch', desc: 'Orders shipped within 24 hours from our office in India.' },
    { icon: 'rotate-ccw', title: 'Easy Returns', desc: 'Not happy with your brew? 7-day hassle-free returns, no questions asked.' },
    { icon: 'shield-check', title: 'Freshness Promise', desc: '100% natural, no preservatives. Packed to retain peak aroma.' },
  ];
  const shipGrid = document.getElementById('ship-grid');
  if (shipGrid) {
    shipGrid.innerHTML = ships.map(s => `
      <div class="ship-card">
        <div class="ship-icon"><i data-lucide="${s.icon}"></i></div>
        <h3>${s.title}</h3>
        <p>${s.desc}</p>
      </div>
    `).join('');
  }

  // Reviews — photos
  const photos = [
    { src: 'https://cdn.shopify.com/s/files/1/0696/5651/0710/files/WhatsApp_Image_2026-05-12_at_1.16.09_PM_1.jpg?v=1778572515', alt: 'Customer holding Dolshyne coffee jar at a cafe', name: '@aanya.m' },
    { src: 'https://cdn.shopify.com/s/files/1/0696/5651/0710/files/testimonial1.png?v=1778496863', alt: 'Top down shot of Dolshyne coffee with berries', name: '@kartik.r' },
    { src: 'https://cdn.shopify.com/s/files/1/0696/5651/0710/files/testimonial3.png?v=1778496863', alt: 'Dolshyne coffee jar gifted with handwritten note', name: '@ishita.b' },
    { src: 'https://cdn.shopify.com/s/files/1/0696/5651/0710/files/WhatsApp_Image_2026-05-12_at_1.16.09_PM.jpg?v=1778572515', alt: 'Dolshyne latte and croissant breakfast spread', name: '@home.brews' },
  ];
  function starsHtml(n=5){ let s=''; for(let i=0;i<n;i++) s+='<i data-lucide="star"></i>'; return s; }
  const photoGrid = document.getElementById('photo-grid');
  if (photoGrid) {
    photoGrid.innerHTML = photos.map(p => `
      <figure class="photo">
        <img src="${p.src}" alt="${p.alt}" loading="lazy">
        <div class="photo-overlay">
          <span class="name">${p.name}</span>
          <div class="stars">${starsHtml()}</div>
        </div>
      </figure>
    `).join('');
  }

  const reviews = [
    { quote: "Finally, an Indian instant coffee with zero chicory. The Original tastes exactly like a fresh Coorg brew — smooth, rich, no bitterness.", name: 'Aanya Mehta', city: 'Mumbai' },
    { quote: "Berry & Cream with chilled tonic water is a vibe. Bold, fruity, creamy — nothing else like it on the market.", name: 'Karthik R.', city: 'Bengaluru' },
    { quote: "The hazelnut flavor feels natural -not too strong, not artificial. Creamy texture with a soothing taste. Perfect for both mornings and late-night cravings.", name: 'Ishita Bose', city: 'Kolkata' },
  ];
  const reviewGrid = document.getElementById('review-grid');
  if (reviewGrid) {
    reviewGrid.innerHTML = reviews.map(r => `
      <figure class="review-card">
        <span class="quote-icon"><i data-lucide="quote"></i></span>
        <div class="stars">${starsHtml()}</div>
        <blockquote class="review-quote">"${r.quote}"</blockquote>
        <figcaption class="review-foot">
          <p class="name">${r.name}</p>
          <p class="city">${r.city}</p>
        </figcaption>
      </figure>
    `).join('');
  }

  // FAQ
  const faqs = [
    { q: 'Is Dolshyne 100% pure coffee?', a: 'Yes. Every Dolshyne product is 100% pure — no chicory, no fillers, no compromise. Just premium Arabica & Robusta beans, curated in small batches.' },
    { q: 'Where do your beans come from?', a: 'Our instant coffees use Arabica & Robusta from the renowned estates of Coorg and Chikmagalur in India.' },
    { q: 'Do you ship across India?', a: 'Yes. We ship Pan India to all major pincodes. Orders above ₹799 get free shipping and most orders are delivered within 3–5 business days.' },
    { q: 'Are the flavoured coffees suitable for vegans?', a: 'Yes. All Dolshyne instant and specialty coffees are 100% plant-based and vegan-friendly. Pair with your favourite dairy or plant milk.' },
    { q: 'What is the shelf life?', a: 'Each container stays fresh for 12 months from the date of packing when stored in a cool, dry place. Once opened, store it in an airtight container and finish within 60 days for peak aroma.' },
  ];
  const faqEl = document.getElementById('faq-list');
  if (faqEl) {
    faqEl.innerHTML = faqs.map((f, i) => `
      <div class="acc-item" data-i="${i}">
        <button class="acc-trigger">${f.q}<i data-lucide="chevron-down"></i></button>
        <div class="acc-content"><div class="acc-content-inner">${f.a}</div></div>
      </div>
    `).join('');
    faqEl.querySelectorAll('.acc-item').forEach(item => {
      const trigger = item.querySelector('.acc-trigger');
      const content = item.querySelector('.acc-content');
      if (trigger && content) {
        trigger.addEventListener('click', () => {
          const open = item.classList.contains('open');
          faqEl.querySelectorAll('.acc-item.open').forEach(o => {
            o.classList.remove('open');
            const oContent = o.querySelector('.acc-content');
            if (oContent) oContent.style.maxHeight = '0px';
          });
          if (!open) {
            item.classList.add('open');
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        });
      }
    });
  }

  // Init lucide icons
  if (window.lucide) {
    lucide.createIcons();
  }
})();


/* Hazelnut - Add to Cart & Quantity Functionality (Redirects to Cart Page) */

(function() {
  const hazelnutQtySpan = document.getElementById('hazelnut-qty');
  const hazelnutMinusBtn = document.getElementById('hazelnut-minus');
  const hazelnutPlusBtn = document.getElementById('hazelnut-plus');
  const hazelnutAddBtn = document.getElementById('hazelnut-add-btn');

  if (hazelnutQtySpan && hazelnutMinusBtn && hazelnutPlusBtn && hazelnutAddBtn) {
    let hazelnutQuantity = 1;

    // Update quantity display
    function updateHazelnutDisplay() {
      hazelnutQtySpan.textContent = hazelnutQuantity;
    }

    // Add to cart function - redirects to CART page (not checkout)
    function addHazelnutToCart() {
      // First add to cart using cart/add endpoint
      const addToCartUrl = `https://www.dolshyne.com/cart/add?id=46288444555510&quantity=${hazelnutQuantity}`;
      
      // Open cart page after adding
      window.location.href = addToCartUrl;
    }

    // Increase quantity
    function increaseQty() {
      hazelnutQuantity++;
      updateHazelnutDisplay();
    }

    // Decrease quantity
    function decreaseQty() {
      if (hazelnutQuantity > 1) {
        hazelnutQuantity--;
        updateHazelnutDisplay();
      }
    }

    // Event listeners
    hazelnutMinusBtn.addEventListener('click', decreaseQty);
    hazelnutPlusBtn.addEventListener('click', increaseQty);
    hazelnutAddBtn.addEventListener('click', addHazelnutToCart);
  }
})();